const style1 = {
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width: "100%",
    maxWidth: "368px"
}
const style2 = {
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = {
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = {
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"126.63044% 0 0 0",
    width:"100%"
}
const style5 = {
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}
function TenCommandEmbed(){
    return (
        <>
        <div className="getty embed image" style={style1}><div style={style2}><a href="http://www.gettyimages.com/detail/AB30590" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/AB30590?et=S758YPGvR-x_noYb9dNM7Q&tld=com&sig=HIpJtTlyWalppw_f0p72dcU1YNqAmuiHnf9s2JGxfS8=&caption=true&ver=1" title="Ten Commandments" scrolling="no" frameBorder="0" width="368" height="466" style={style5}></iframe></div></div>
        </>
    );
};
export default TenCommandEmbed;